import uiRouter from 'angular-ui-router';
import angulartics from 'angulartics';

import gazelleSpinner from 'gazelle/src/components/spinner/spinner.module';
import rhinoCore from 'rhino/src/core/core.module';

import * as redirect from './redirect.controller';

import './redirect.scss';

export default angular.module('register.components.redirect', [
  uiRouter,
  angulartics,
  gazelleSpinner,
  rhinoCore,
])
  .controller(redirect.name, redirect.default)
  .name;



// WEBPACK FOOTER //
// ./components/redirect/redirect.module.js